import React, {useEffect, useContext, useReducer, useMemo} from 'react'
import {UserContext} from './UserContext'
import { TourContext } from "../index"
import {login} from "../../api/api"
import {AUTH_NOT_AUTHORIZED, USER_ACTION} from '../../constant'
import {removeCookie, setCookie} from "../../utils";

const initialUser = {
	auth: null,
	categories: [],
	isExternalUser: false,
	login: null,
}

const userReducer = (state, action) => {
	switch (action.type){
		case USER_ACTION.LOGIN: {
			return {
				...state,
				auth: action.payload,
			}
		}
		case USER_ACTION.LOGOUT: {
			return initialUser
		}
		case USER_ACTION.SET_CATEGORIES: {
			return {
				...state,
				categories: action.payload,
			}
		}
		case USER_ACTION.SET_PARAMS: {
			return {
				...state,
				...action.payload,
			}
		}
		default: {
			return state
		}
	}
}

export function UserProvider({ children }){
	const [user, dispatch] = useReducer(userReducer, initialUser)
	const { tour, openTour } = useContext(TourContext)
	const contextValue = useMemo(() => ({
			user,
			dispatchUser: dispatch,
			setUserParams: (data) => dispatch({type: USER_ACTION.SET_PARAMS, payload: data}),
			setUserCategories: (categories) => dispatch({type: USER_ACTION.SET_CATEGORIES, payload: categories}),
		}), [user]);

	useEffect(() => {
		async function fetchLogin() {
			const data = await login();
			if(data.auth === AUTH_NOT_AUTHORIZED){
				removeCookie('tour');
			}
			dispatch({type: USER_ACTION.SET_PARAMS, payload: {...data, ...(tour.tour ? {categories: []}: null)}})
		}
		fetchLogin()
	}, [])

	return (
		<>{user.auth && user?.categories
			? <UserContext.Provider value={contextValue}>{children}</UserContext.Provider>
			: null
	    }</>
	);
};
